import Vue from 'vue'
import freshVueNotes from '@freshsolutions/fresh-vue-notes'
import { apolloClient } from '@/plugins/vue-apollo'
import i18n from './i18n'

Vue.use(freshVueNotes, {
  i18n: i18n,
  apollo: apolloClient
})
